import { useMutation } from "@tanstack/react-query";
import { useShallow } from "zustand/react/shallow";

import { setApplicationFlowFormErrors } from "@krea/common/services/formService";
import { useBankIDStore } from "@krea/common/store/bankID/hooks";
import { useLoanApplicationFormStore } from "@krea/common/store/loan-application-form/hooks";
import { getApplicationPayload } from "@krea/common/store/loan-application-form/utils";
import { BANKID_AUTHENTICATE_STORE_KEY } from "@krea/common/store/queryClient";
import { BANKID_FLOW_STATES, HINT_CODE_STATES } from "@krea/common/utils";

import { initiateApplicationViaBankID } from "store/loan-application-form/api";

export const useInitiateMutation = (onInit) => {
  const setOrderRef = useBankIDStore((state) => state.setOrderRef);

  const { setRemoteIdentification } = useLoanApplicationFormStore(
    useShallow((state) => ({
      setRemoteIdentification: state.setRemoteIdentification,
    })),
  );

  const appPayload = getApplicationPayload();

  return useMutation({
    onMutate: () => {
      if (onInit) {
        onInit();
      }
    },
    mutationFn: async () => initiateApplicationViaBankID(appPayload),
    onSuccess: (data) => {
      const {
        orderRef = null,
        url = null,
        expiresAt = null,
      } = data?.initiatePendingLoanApplication || {};

      setOrderRef(orderRef);
      setRemoteIdentification({ URL: url, URLExpiryDate: expiresAt });
    },
    onError: (err) => {
      console.error("Failed to initiate loan application", err);
      const hasFormErrors = setApplicationFlowFormErrors(err);
      return {
        status: BANKID_FLOW_STATES.FAILED,
        hintCode: HINT_CODE_STATES.ERROR,
      };
    },
  });
};
